/**
 * Created by MRLWJ on 2017/6/25.
 */
//获取当前页面的get参数
function getQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]); return null;
}
//获取指定的url的get参数
function getQueryStringByStr(name,url){
    var aQuery = url.split("?");
    var aGET = new Array();
    if(aQuery.length > 1){
        var aBuf = aQuery[1].split("&");
        for(var i=0, iLoop = aBuf.length; i<iLoop; i++){
            var aTmp = aBuf[i].split("=");
            aGET[aTmp[0]] = aTmp[1];
        }
    }
    return aGET[name];
}
//js 跳转
function to(addr) {
    $.ajax({
        url: addr,
        data:{},
        type: "GET",
        success:function (result) {
            if(result.code == 301 && result.data.length > 0){
                triggerAElem(result.data);
            }else{
                triggerAElem(addr);
            }
        },
        error:function (data) {
            layer.msg("无法访问服务器");
        }
    });
}
function triggerAElem(addr) {
    window.location.href = addr;
}
//处理post 301错误
function handlePost301(link){
    if (window.DSSX && DSSX.util && DSSX.util.handle301) {
        return DSSX.util.handle301(link);
    }

    var linkHost = link.split("?")[0]; // 形如："http://sso.dyfchk2.kuxiao.cn/sso/index.html"
    var curLink = window.location.href.split("token")[0]; //http://dssxs.dyfchk2.kuxiao.cn/usr/api/quotePage?rfqId=594f40fee3051933997db7a1&"
    var redirectLink = linkHost + "?url=" + curLink;

    window.location.href = redirectLink;
}

// 获取token
function TokenHelper(){
    this.getToken = function () {
        var token = window.DSSX && DSSX.appProp && (token = DSSX.appProp.token);
        return token || getQueryString("token") || getCookie("token");
    };
}

function getCookie(c_name)
{
    if (document.cookie.length>0)
    {
        c_start=document.cookie.indexOf(c_name + "=")
        if (c_start!=-1)
        {
            c_start=c_start + c_name.length+1
            c_end=document.cookie.indexOf(";",c_start)
            if (c_end==-1) c_end=document.cookie.length
            return unescape(document.cookie.substring(c_start,c_end))
        }
    }
    return ""
}

function bindCopyLink(selector,val){
    var clipboard  = new Clipboard(selector,{
        text:function() {
            return val();
        }
    });
    clipboard.on('success', function(e) {
        layer.msg('复制成功！');
    });

    clipboard.on('error', function(e) {
        layer.msg('复制失败..请手动复制', {icon: 5});
    });
}

function PostHandler(){
    var thiz = this;
    this.token = new TokenHelper("").getToken();
    this.json = "";
    this.onSuccess = null;
    this.onError = null;

    this.url = "";
    //开始post数据
    this.start = function(){

        $.ajax({
            type: 'POST',
            url:   thiz.url,
            data: thiz.json,
            success: function (data) {
                if(data.code === 0){
                    thiz.onSuccess && thiz.onSuccess(data);
                } else if(data.code === 301){
                    handlePost301(data.data);
                    thiz.onError && thiz.onError(data);
                }else{
                    if (DSSX.dialog) {
                        DSSX.dialog.err({data: {data: data}}, {
                            moduleName: 'PostHandler',
                            funcName: thiz.url,
                            text: '',
                        })
                    } else {
                        layer.msg("操作失败，错误码：" + data.code);
                    }
                    thiz.onError && thiz.onError(data);
                }
                console.log("PostHandler response data", data);
            },
            dataType: "json",
            contentType: "application/json"
        });
    }
}

//将模板的数据替换成相对应商品数据
//template   模板
//data       json数据
var template_replace = function (template, data) {
    var safeFunc = null;

    function get_next_placeholder_index_range() {
        var leftIndex = template.indexOf('{', 0);
        var rightIndex = template.indexOf('}', leftIndex);
        if (leftIndex === -1 || rightIndex === -1) {
            return false;
        } else {
            return {left: leftIndex, right: rightIndex};
        }
    }

    function set_replacement(indexRange) {
        var key = template.slice(indexRange.left + 1, indexRange.right);

        var index = key.indexOf('.');
        if (index === -1) {
            template = template.replace('{' + key + '}', data[key]);
        } else {
            template = template.replace('{' + key + '}', getValueByPath(data, key));
        }

        begin_replace();
    }

    function begin_replace() {
        var indexRange = get_next_placeholder_index_range();
        if (indexRange) {
            set_replacement(indexRange);
        }
    }

    function getValueByPath(data, path, defaultVal) {
        if (!safeFunc) {
            if (window.DSSX && DSSX.util && DSSX.util.safe) {
                safeFunc = DSSX.util.safe;
            }
        }
        return safeFunc && safeFunc(data, path, defaultVal);
    }

    begin_replace();
    return template;
};

// 时间戳转日期
function getLocalTime(nS) {
    return new Date(parseInt(nS)).toLocaleString().replace(/年|月/g, "-").replace(/日/g, " ");
}

//保留小数位
function ForDight(Dight,How){
    Dight = Math.round(Dight*Math.pow(10,How))/Math.pow(10,How);
    return Dight;
}
function getFloatVal(obj,html) {
    var v ;
    if(html){
        v = parseFloat(obj.html());
    }else{
        v = parseFloat(obj.val());
    }
    if(!(v >= 0)){
        v = 0;
    }
    return v;
}

//jpg, jpeg, png, gif, tif, bmp, doc, xls, txt, pdf, zip, rar, docx, xlsx
function getPreview(fileDownUrl,fileName) {
    var ext = fileName.substring(fileName.lastIndexOf('.') + 1);
    //TODO 添加其他文件的图标url选择
    switch(ext){
        case "jpg":
        case "jpeg":
        case "png":
        case "gif":
        case "bmp":
            return fileDownUrl;
        case "tif":
        case "doc":
        case "xls":
        case "txt":
        case "pdf":
        case "zip":
        case "rar":
        case "docx":
        case "xlsx":
            return "/imgs/file-icon.png";
        default:
            return null;
    }
}

//绑定头部的点击事件，回到首页
function bindToIndex(seltor) {
    if(!seltor){
        seltor = ".my-ali-cc,.head-icon-cc";
    }
    $(seltor).click(function(){
        window.location.href = "/";
    });
}

//轮询执行逻辑
var _runs = [];
function startWatch(){
    return setInterval(function(){
        for(var i = 0;i<_runs.length;i++){
            _runs[i](i);
        }
    },200);
}
var _tag = startWatch();
function addToWatch(run){
    _runs.push(run);
}
function removeWatch(i){
    window.clearInterval(_tag);
    _runs.splice(i,1);
    _tag = startWatch();
}

// test for watch
function testWatch() {
    addToWatch(function(){
        console.log(1);
    });
    addToWatch(function(){
        console.log(2);
    });
    addToWatch(function(i){
        console.log(3);
        removeWatch(i);
    });
}
//获取订单的状态
function getOrderStatus(id,onGet) {
    var getHandler = new GetHandler();
    getHandler.url = "/pub/api/getCreditOrder?orderId="+id;
    getHandler.onSuccess = function (data) {
        onGet(data.creditOrder.status);
    };
    getHandler.onError = function (json,msg) {
        layer.alert("获取订单状态失败。" + msg, {icon: 2});
        console.log(json);
    };
    getHandler.start();
}
// 修改订单状态
function changeStatus(opt) {
    if (!opt.curAction) {
        opt.curAction = "";
    }
    var getHandler = new GetHandler();
    getHandler.url = "/pub/api/updateOrderStatus?orderId=" + opt.id + "&status=" + opt.newStatus + "&action=" + opt.curAction;
    getHandler.onSuccess = function (data) {
        opt.ok(data);
    };
    getHandler.onError = function (json, msg) {
        layer.alert("操作失败了。" + msg, {icon: 2});
        console.log(json);
    };
    getHandler.start();
}

if (typeof jQuery != 'undefined') {
    $(function(){
        //   <link rel="stylesheet" href="iframe/css/index_header.css">
        //    <div header></div>
        var header = $("div[header]");
        header.load("/base.html .head-cc",function () {
            // bindToIndex();
            //代表要高亮哪一个 选项【0业务  1商圈  2账户】
            var extra = parseInt(header.attr("extra"));
            if(extra >= 0){
                var e = $("#extra-cc");
                e.show();
                $(e.find(".item")[extra]).addClass("hl");
            }
        });
        $("div[service]").load("/base.html #service-cc");


        $("div[dynamic-nav]").load("/base.html #dynamic-nav", function () {
            loadFavoriteMenu();
        });

        $("div[pagination]").load("/base.html #pagination",function () {
            _paginationLoaded = true;
        });

    });
}

var _paginationLoaded = false;
function onPaginationLoad(run){
    var once = false;
    addToWatch(function (i) {
        if(_paginationLoaded){
            if(!once){
                run();
                once = true;
            }else{
                removeWatch(i);
            }
        }
    })
}

function PaginationClass(selector){
    var thiz = this;
    var jqObj = $(selector);
    var selectedClass = "no-pointer";
    var itemTmpl = jqObj.find(".item").clone();

    var container = jqObj.find("[name=c]");

    var totalPage = 0;
    var items = [];
    this.setTotalPage = function(total,curSelectPage){
        container.empty();
        totalPage = total;
        if(total > 7){
            for(var i = 1;i<=7;i++){
                cloneItem(i);
            }
            cloneItem().html("...").addClass(selectedClass);
            cloneItem(total);
        }else{
            for(var i = 1;i<= total;i++){
                cloneItem(i);
            }
        }
        items = jqObj.find(".item");
        if(!curSelectPage){
            curSelectPage = 1;
        }
        cur = curSelectPage;
        $(items.get(cur - 1)).addClass(selectedClass);

    };

    function cloneItem(index){
        var clone = itemTmpl.clone();
        container.append(clone);
        if(index){
            clone.click(function(){
                thiz.setCurPage(index);
            });
            clone.html(index);
        }
        return clone;
    }
    var cur = 1;
    var nextBtn = jqObj.find(".next");
    var preBtn = jqObj.find(".pre");

    this.setCurPage = function (c) {
        if(c > totalPage || c <= 0 || isNaN(c) || c == cur){
            return ;
        }
        if(c > 7){
            return ;
        }
        $(items.get(cur-1)).removeClass(selectedClass);
        $(items.get(c-1)).addClass(selectedClass);
        cur = c;
        if(cur == 1){
            preBtn.removeClass("enable");
        }else{
            preBtn.addClass("enable");
        }
        if(cur == totalPage){
            nextBtn.removeClass("enable");
        }else{
            nextBtn.addClass("enable");
        }
        thiz.onPageChange(c);
    };

    var toPageObj =  jqObj.find("#go-input");
    jqObj.find(".goto-btn").click(function(){
        var goto = parseInt(toPageObj.val());
        if(goto<1){
            toPageObj.val(1);
            goto = 1;
        }
        if(goto > totalPage){
            toPageObj.val(totalPage);
            goto = totalPage;
        }
        thiz.setCurPage(goto);
    });
    nextBtn.click(function(){
        thiz.setCurPage(cur + 1);
    });
    preBtn.click(function(){
        thiz.setCurPage(cur - 1);
    });

    this.onPageChange = function(){};
}

// 显示一键复制的弹窗
function showAlert(val,msgHtml,final){
    var clipboard = new Clipboard('.layui-layer-btn0', {
        text: function(e) {
            return val();
        }
    });
    clipboard.on('success', function(e) {
        layer.msg('复制成功', {icon: 1});
    });
    clipboard.on('error', function(e) {
        layer.msg('复制失败，请手动复制', {icon: 5});
    });
    if(final){
        var img = '<img src="imgs/big_gou.png"style="margin: 10px 120px;display: inline-block;width: 64px"><br/>';
        layer.confirm(img + msgHtml, {
            btn: ['点击复制','取消'],
            title:"订单已完成"
        });
    }else{
        layer.confirm(msgHtml, {
            btn: ['点击复制','取消'],
            title:"通知"
        });
    }

}

//时间戳转为时间
function add0(m) {
    return m < 10 ? '0' + m : m
}
function timeFormat(timeInt) {
    var time = new Date(timeInt);
    var y = time.getFullYear();
    var m = time.getMonth() + 1;
    var d = time.getDate();
    return y + '-' + add0(m) + '-' + add0(d);
}

//执行此方法保证token有效
//简单使用方式如下：mustVaildToken(new uploader().getFileUploadAddr());
function mustVaildToken(urlWithToken,onTokenValid){
    var getHandler = new GetHandler();
    getHandler.url = urlWithToken;
    getHandler.onError = getHandler.onSuccess = function () {
        if(onTokenValid){
            onTokenValid();
        }
    };
    getHandler.start();
}

function loadFavoriteMenu() {

    var favoriteMenuEle = $('#favorite-menu');
    var favoriteMenuConf = window.localStorage.getItem('dssx_favorite_menu');
    var favoriteMenu = JSON.parse(favoriteMenuConf);

    for (var i = 0; i < favoriteMenu.length; i++) {
        var temp = '<li><a href="' + favoriteMenu[i].url + '">' + favoriteMenu[i].zhCN + '</a></li>';
        favoriteMenuEle.append(temp);
    }
}